<template>
  <div class="payment">
    <div class="payment__header">
      <div class="payment__header--left">
        <h2 class="large-title" >Payment</h2>
        <p v-if="!orderNotFound" class="small-font">Set payment for campaign</p>
      </div>
    </div>
    <div v-if="isLoadInfo" class="payment__loading">
      <adx-loading slot="loading" />
    </div>
    <template v-if="!isLoadInfo && !orderNotFound">
      <!-- <div class="payment__breadcrumb">
        <adx-breadcrumb :items="breadcrumb" />
      </div> -->
      <div class="payment__content">
        <div class="payment__content--left">
          <div class="payment__content__info">
            <div class="header">
              <span class="subhead strong">Personal Information</span>
            </div>
            <div class="payment__content__info__fields">
              <adx-input :ref="dataRef.fullName" :inputId="dataRef.fullName" :label="`Fullname *`" :error.sync="fullNameError" :validation="['NotEmpty', 'MinLength:2', 'MaxLength:100']" :value.sync="fullName" />
            </div>
          </div>
          <div class="payment__content__info">
            <div class="header">
              <span class="subhead strong">Contact Information</span>
            </div>
            <div class="payment__content__info__fields">
              <adx-input :ref="dataRef.email" :inputId="dataRef.email" :label="`Email Address *`" :error.sync="emailAddressError" :validation="['NotEmpty', 'Email']"  :value.sync="emailAddress" />
              <adx-input :ref="dataRef.mobile" :inputId="dataRef.mobile" :label="`Phone Number *`" :error.sync="mobileError" :validation="['NotEmpty', 'Phone', 'Numeric', 'MinLength:7', 'MaxLength:15']" :value.sync="mobile" />
            </div>
            <div class="payment__content__info__field">
              <adx-input :label="`Company Name`" :value.sync="company" />
            </div>
            <div class="payment__content__info__field">
              <adx-textarea :ref="dataRef.address" :inputId="dataRef.address" :label="`Billing Address *`" :error.sync="addressError" :validation="['NotEmpty', 'MinLength:5']" :value.sync="address" />
            </div>
          </div>
          <div class="payment__content__info">
            <div class="payment__content__info__field">
              <input id="tax-checkbox" class="regular-checkbox" type="checkbox" @click.stop="checkBoxClicked" />
              <label for="tax-checkbox" class="regular-checkbox-label"></label>
              <span class="subhead">Request tax invoice for this transaction</span>
            </div>
            <div class="payment__content__info__fields" v-if="isChecked">
              <adx-input :ref="dataRef.npwpNumber" :inputId="dataRef.npwpNumber" :label="`NPWP Number *`" :error.sync="npwpNumberError" :validation="['NotEmpty', 'Numeric', 'MinLength:15', 'MaxLength:15']" :value.sync="npwpNumber" />
              <adx-input :ref="dataRef.npwpName" :inputId="dataRef.npwpName" :label="`NPWP Name *`" :error.sync="npwpNameError" :validation="['NotEmpty', 'MinLength:2', 'MaxLength:100']" :value.sync="npwpName" />
            </div>
            <div class="payment__content__info__field" v-if="isChecked">
              <adx-textarea :ref="dataRef.npwpAddress" :inputId="dataRef.npwpAddress" :label="`NPWP Address *`" :error.sync="npwpAddressError" :validation="['NotEmpty', 'MinLength:5']"  :value.sync="npwpAddress" />
            </div>
          </div>
        </div>
        <div class="payment__content--right">
          <div class="payment__content__order-summary">
            <div class="payment__content__order-summary__header">
              <span class="subhead strong">Order Summary</span>
            </div>
            <div class="payment__content__order-summary__info">
              <div class="payment__content__order-summary__info__content" v-for="(campaign, index) in campaigns" :key="index">
                <div class="payment__content__order-summary__info__content--left subhead">
                  {{ campaign.title }}
                </div>
                <div class="payment__content__order-summary__info__content--right">
                  <span class="subhead strong">{{priceBeforeTax(campaign.net_price) | formatMoney}}</span>
                </div>
                <div class="payment__clear-both"></div>
              </div>
              <div class="payment__content__order-summary__info__content">
                <div class="payment__content__order-summary__info__content--left">
                  <span class="subhead">PPN 10%</span>
                </div>
                <div class="payment__content__order-summary__info__content--right">
                  <span class="subhead strong">{{ vat | formatMoney}}</span>
                </div>
                <div class="payment__clear-both"></div>
              </div>
              <div class="breaker"></div>
              <div class="payment__content__order-summary__info__content">
                <div class="payment__content__order-summary__info__content--left">
                  <span class="subhead strong">Sub Total</span>
                </div>
                <div class="payment__content__order-summary__info__content--right">
                  <span class="subhead strong">{{ totalOrder | formatMoney}}</span>
                </div>
                <div class="payment__clear-both"></div>
              </div>
              <div v-if="adxBalance !== 0" class="payment__content__order-summary__info__content">
                <div class="payment__content__order-summary__info__content--left">
                  <span class="subhead strong">ADX Balance</span>
                </div>
                <div class="payment__content__order-summary__info__content--right">
                  <span class="subhead strong">- {{ adxBalance | formatMoney}}</span>
                </div>
                <div class="payment__clear-both"></div>
              </div>
              <div v-if="discount !== 0" class="payment__content__order-summary__info__content">
                <div class="payment__content__order-summary__info__content--left">
                  <span class="subhead strong">Discount</span>
                </div>
                <div class="payment__content__order-summary__info__content--right">
                  <span class="subhead strong">- {{ discount | formatMoney}}</span>
                </div>
                <div class="payment__clear-both"></div>
              </div>
            </div>
          </div>
          <div class="payment__content__price">
            <div class="payment__content__price--left">
              <span class="strong subhead">Total Price</span>
            </div>
            <div class="payment__content__price--right">
              <span class="payment__content__price__total regular-font">{{totalPrice | formatMoney}}</span>
            </div>
            <div class="payment__clear-both"></div>
          </div>
          <div class="payment__content__promo-code">
            <div class="header">
              <span class="strong subhead">Promo Code</span>
            </div>
            <div v-if="!isPromoCodeValid" class="payment__content__promo-code__wrapper">
              <adx-input :ref="dataRef.promoCode" :inputId="dataRef.promoCode" :button="`Use`" :label="`Input Promo Code`" :error.sync="promoCodeError" :value.sync="promoCode" @buttonClicked="useVoucher" :upperCase="true"/>
            </div>
            <div v-else class="payment__content__promo-code__wrapper">
              <div if class="payment__content__promo-code__wrapper__dialog">
                <div class="payment__content__promo-code__wrapper__dialog__button">
                  <i class="adx-ic_close" @click="unuseVoucher"></i>
                </div>
                <div class="payment__content__promo-code__wrapper__dialog__header">
                  <span>Kode Promo: </span>
                  <span class="code">{{promoCode}}</span>
                </div>
                <div class="payment__content__promo-code__wrapper__dialog__description">
                  <span>
                    Congrats! you get discount - {{discount | formatMoney}} for this transaction
                  </span>
                </div>
              </div>
              <span v-if="promoCodeError" class="payment__content__promo-code__error"> {{promoCodeError}} </span>
            </div>
            <div class="payment__clear-both"></div>
          </div>
          <div class="payment__content__buttons">
            <button class="btn-block primary paynow not-rounded" @click.stop="checkBeforePay()" :disabled="loadingMidTrans">
              Pay Now
            </button>
            <adx-loading-white v-if="loadingMidTrans" class="loading-circle" />
          </div>
          <div class="payment__content__buttons-fixed">
            <button class="btn-block primary paynow not-rounded" @click.stop="checkBeforePay()" :disabled="loadingMidTrans">
              Pay Now
            </button>
            <adx-loading-white v-if="loadingMidTrans" class="loading-circle" />
          </div>
        </div>
      </div>
    </template>
    <div v-if="!isLoadInfo && orderNotFound" class="payment__not_found">
      <img src="/img/notfound/notfound@2x.png" alt="">
      <p class="not-found large-font strong">Order not found.</p>
    </div>
    <adx-modal v-if="isModalOpen" @modal-close="toggle">
      <div slot="content">
        <div class="payment__modal">
          <div class="top">Do you want to save your personal data changes?</div>
          <div class="bottom">
            <button class="btn-small secondary" @click.stop="pay()">No</button>
            <button class="btn-small primary" @click.stop="saveProfile()">Yes</button>
          </div>
        </div>
      </div>
    </adx-modal>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'
import Input from '@/components/Form/Input'
import TextArea from '@/components/Form/TextArea'
import Checkbox from '@/components/Form/Checkbox'
import Loading from '@/components/Loading/Primary'
import LoadingSpinner from '@/components/Loading/Secondary'
import LoadingSpinnerWhite from '@/components/Loading/Secondary-white'
import Modal from '@/components/Modal'
import api from '@/api'
import { apiV2 } from '@/api/urls'
import { midtransConfig } from '@/lib/config'

export default {
  name: "adx-order-detail",
  components: {
    'adx-breadcrumb': Breadcrumb,
    'adx-input': Input,
    'adx-textarea': TextArea,
    'adx-checkbox': Checkbox,
    'adx-modal': Modal,
    'adx-loading': Loading,
    'adx-loading-secondary': LoadingSpinner,
    'adx-loading-white': LoadingSpinnerWhite
  },
  data(){
    return {
      breadcrumb: [
        {
          title: '1. Invoice Details',
          isCurrent: true
        },
        {
          title: '2. Payment Method',
          isCurrent: false
        }
      ],
      dataRef: {
        fullName: 'fullName',
        email: 'email',
        mobile: 'mobile',
        address: 'address',
        npwpNumber: 'npwpNumber',
        npwpName: 'npwpName',
        npwpAddress: 'npwpAddress',
      },
      mapDataAPI: {
        // api key: front end key (from dataRef key)
        email: 'email',
        full_name: 'fullName',
        mobile: 'mobile',
        address: 'address',
        npwp_number: 'npwpNumber',
        npwp_name: 'npwpName',
        npwp_address: 'npwpAddress',
      },
      campaigns: [],
      user: {},
      orderId: 0,
      orderNotFound: false,
      isLoadInfo: false,
      isLoadTotalOrder: false,
      loadingMidTrans: false,
      isChecked: false,
      fullName: '',
      company: '',
      emailAddress: '',
      mobile: '',
      address: '',
      npwpNumber: '',
      npwpName: '',
      npwpAddress: '',
      promoCode: '',
      promoNominal: 0,
      discount: 0,
      fullNameError: '',
      companyError: '',
      emailAddressError: '',
      mobileError: '',
      addressError: '',
      npwpNumberError: '',
      npwpNameError: '',
      npwpAddressError: '',
      promoCodeError: '',
      vat: 0,
      subTotal: 0,
      adxBalance: 0,
      totalOrder: 0,
      isModalOpen: false,
      fullNameTemp: '',
      companyTemp: '',
      emailAddressTemp: '',
      mobileTemp: '',
      addressTemp: '',
      npwpNumberTemp: '',
      npwpNameTemp: '',
      npwpAddressTemp: '',
      isSaved: false,
      isPromoCodeValid: false,
    }
  },
  created() {
    let newScript = document.createElement('script')
    newScript.setAttribute('src', midtransConfig.lib)
    newScript.setAttribute('data-client-key', midtransConfig.key)
    document.head.appendChild(newScript)
  },
  beforeMount() {
    if (this.$route.params && this.$route.params.id) {
      this.orderId = this.$route.params.id
    }
  },
  mounted() {
    this.getOrderDetail()
  },
  methods: {
    priceBeforeTax(price) {
      return Math.round((100/110) * price)
    },
    checkBoxClicked() {
      this.isChecked = !this.isChecked
    },
    getOrderDetail() {
      (async () => {
        this.isLoadInfo = true
        let response = await api.get(apiV2.orderDetail(this.orderId), {needToken: true})
        if (response.status == 200) {
          this.campaigns = response.data.campaigns
          let user = response.data.user
          if (user) {
            this.fullName = user.full_name,
            this.company = user.company,
            this.emailAddress = user.email,
            this.mobile = user.phone,
            this.address = user.address
            this.npwpNumber = user.npwp_number,
            this.npwpName = user.npwp_name,
            this.npwpAddress = user.npwp_address
            // Temporary for personal data changes checking
            this.fullNameTemp = user.full_name,
            this.companyTemp = user.company,
            this.emailAddressTemp = user.email,
            this.mobileTemp = user.phone,
            this.addressTemp = user.address
            this.npwpNumberTemp = user.npwp_number,
            this.npwpNameTemp = user.npwp_name,
            this.npwpAddressTemp = user.npwp_address
          }
          this.isLoadInfo = false
        } else {
          if (response.status == 404 || response.status == 403) {
            this.orderNotFound = true
          }
          this.isLoadInfo = false
        }
      })();
    },
    checkZero() {
      if (this.totalPrice == 0) {
        (async () => {
          this.loadingMidTrans = true
          let data = {
            email: this.emailAddress,
            full_name: this.fullName,
            mobile: this.mobile,
            address: this.address,
            company: this.company,
            request_tax: this.isChecked
          }
          if (this.promoCode) data.voucher_code = this.promoCode
          if (this.isChecked) {
            data.npwp_number = this.npwpNumber
            data.npwp_name = this.npwpName
            data.npwp_address = this.npwpAddress
          }
          let response = await api.post(apiV2.midtransToken(this.orderId), data, {needToken: true})
          if (response.status == 201) {
            snap.pay(response.data.token)
            this.loadingMidTrans = false
          } else if (response.status == 400) {
            for (let key in response.data) {
              this.raiseError(this.mapDataAPI[key])
            }
          }
        })();
      }
    },
    pay() {
      this.isModalOpen = false
      this.isSaved = false;
      (async () => {
        this.loadingMidTrans = true
        let data = {
          email: this.emailAddress,
          full_name: this.fullName,
          mobile: this.mobile,
          address: this.address,
          company: this.company,
          request_tax: this.isChecked
        }
        if (this.promoCode) data.voucher_code = this.promoCode
        if (this.isChecked) {
          data.npwp_number = this.npwpNumber
          data.npwp_name = this.npwpName
          data.npwp_address = this.npwpAddress
        }
        if (this.totalPrice !== 0) {
          let response = await api.post(apiV2.midtransToken(this.orderId), data, {needToken: true})
          if (response.status == 201) {
            snap.pay(response.data.token)
            this.loadingMidTrans = false
          } else if (response.status == 400) {
            for (let key in response.data) {
              this.raiseError(this.mapDataAPI[key])
            }
          }
        } else {
          let response = await api.post(apiV2.zeroPayment(this.orderId), data, {needToken: true})
          if (response.status == 201) {
            this.$router.push({ name: 'transaction' })
          } else if (response.status == 400) {
            for (let key in response.data) {
              this.raiseError(this.mapDataAPI[key])
            }
          }
        }
      })();
    },
    validate_user_billing() {
      let data = { isValid: true, id: null }
      let dataRef = this.dataRef

      for (let key in this.dataRef) {
        if (key == 'npwpNumber' || key == 'npwpName' || key == 'npwpAddress') {
          if (!this.isChecked) {
            continue
          }
        }
        
        let value = document.getElementById(dataRef[key]).value
        if (!value || this.inputInvalid(dataRef[key])) {
          data.isValid = false
          data.id = this.dataRef[key]
          break
        }
      }

      return data
    },
    raiseError(id) {
      let element = this.$refs[id].$el.firstElementChild
      element.focus()
      element.blur()
    },
    inputInvalid(value) {
      let error = ''
      let dataRef = this.dataRef
      switch(value) {
        case dataRef.fullName:
          error = this.fullNameError
          break
        case dataRef.email:
          error = this.emailAddressError
          break
        case dataRef.mobile:
          error = this.mobileError
          break
        case dataRef.address:
          error = this.addressError
          break
        case dataRef.npwpNumber:
          error = this.npwpNumberError
          break
        case dataRef.npwpName:
          error = this.npwpNameError
          break
        case dataRef.npwpAddress:
          error = this.npwpNumberError
          break
      }

      return error
    },
    toggle() {
      this.isModalOpen = !this.isModalOpen
    },
    checkBeforePay() {
      // Form validation
      let validation = this.validate_user_billing()
      if (validation.isValid) {
        // If valid check profile data changes
        if (this.fullNameTemp != this.fullName || 
          this.companyTemp != this.company ||
          this.emailAddressTemp != this.emailAddress ||
          this.mobileTemp != this.mobile ||
          this.addressTemp != this.address ||
          this.npwpNumberTemp != this.npwpNumber ||
          this.npwpNameTemp != this.npwpName ||
          this.npwpAddressTemp != this.npwpAddress) {
          this.toggle()
        } else {
          this.pay()
        }
      } else {
        this.raiseError(validation.id)
      }
    },
    saveProfile() {
      (async () => {
        this.loadingMidTrans = true
        this.toggle()
        let data = {
          'full_name': this.fullName,
          'email': this.emailAddress,
          'mobile': this.mobile,
          'address': this.address,
          'company': this.company,
          'npwp_number': this.npwpNumber,
          'npwp_name': this.npwpName,
          'npwp_address': this.npwpAddress
        }
        const response = await api.put(apiV2.userProfile, data, { needToken: true })
        if (response.status === 200) {
          this.$notify({
            group: 'saved',
            title: `success`,
            text: `edit profile success`,
            type: 'success'
          })
          this.pay()
        } else {
          this.$notify({
            group: 'saved',
            title: `failed`,
            text: `edit profile failed`,
            type: 'warn'
          })
        }
      })();
    },
    useVoucher() {
      this.promoCodeError = ''
      this.discount -= this.promoNominal;
      (async () => {
        let params = {
          voucher_code: this.promoCode
        }
        const response = await api.get(apiV2.checkVoucher, { needToken: true, params: params })
        if (response.status == 200) {
          this.promoNominal = response.data.nominal
          this.discount += response.data.nominal
          if (this.totalPrice <= 0) {
            this.promoNominal += this.totalPrice
            this.discount += this.totalPrice
          } else if (this.totalPrice < 9999 ) {
            this.promoCodeError = 'Total price should not be be between Rp 0 and Rp 10.000'
            this.loadingMidTrans = true
          } 
          this.isPromoCodeValid = true
        } else {
          this.isPromoCodeValid = false
          this.promoCodeError = response.data.message
        }
      })();
    },
    unuseVoucher() {
      this.isPromoCodeValid = false
      this.loadingMidTrans = false
      this.discount -= this.promoNominal
      this.promoNominal = 0
    }
  },
  watch: {
    campaigns(newValue, oldValue) {
      if (newValue.length > 0) {
        newValue.forEach(campaign => {
          this.totalOrder += campaign.net_price
          this.adxBalance += campaign.balance
          this.discount += campaign.discount
        });
        this.subTotal = Math.round((100/110) * this.totalOrder)
        this.vat = this.totalOrder - this.subTotal
      }
    },
    promoCode: function () {
      this.promoCode = this.promoCode.toUpperCase()
    },
  },
  computed: {
    totalPrice() {
      return this.totalOrder - this.discount - this.adxBalance
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>

<style lang='scss'>
@import '~@/styles/variables';
@import '~@/styles/mixins';

.input input {
  height: 62px;
}

@include breakpoint (md) {
  .input{
    input {
      height: 46px;
      font-size: 12px;

      &:valid ~ label {
        font-size: 10px;
      }
    }
  }

  .textArea {
    textArea {
      font-size: 12px;

      &:valid ~ label {
        font-size: 10px;
      }
    }
  }

  .selectDropdown {
    .select {
      input {
        min-height: unset !important;
        height: 46px;
        font-size: 12px;

        &:valid ~ .select__title {
          font-size: 10px;
        }
      }
      // .select__icon {
      //   top: 15px;
      // }
    }
  }
}
</style>